const menuHeader = document.querySelector('.m-nav--header');
const menuItems = menuHeader.querySelectorAll('.menu-item');
const dropDownAbout = document.querySelector('.m-dropDown--about');
const dropDownServices = document.querySelector('.m-dropDown--services');
const dropDownProjects = document.querySelector('.m-dropDown--projects');

function menuDropDown(link) {
  const target = link.currentTarget;

  dropDownAbout.classList.remove('active');
  dropDownServices.classList.remove('active');
  dropDownProjects.classList.remove('active');

  if(target.classList.contains('m__dropDown--about')) {
    dropDownAbout.classList.add('active');
  } else if(target.classList.contains('m__dropDown--services')) {
    dropDownServices.classList.add('active');
  } else if(target.classList.contains('m__dropDown--projects')) {
    dropDownProjects.classList.add('active');
  }
}

function hideDropDown() {
  dropDownAbout.classList.remove('active');
  dropDownServices.classList.remove('active');
  dropDownProjects.classList.remove('active');
}

menuItems.forEach((menuItem) => {
  menuItem.addEventListener('mouseover', menuDropDown);
})

dropDownAbout.addEventListener('mouseleave', hideDropDown);
dropDownServices.addEventListener('mouseleave', hideDropDown);
dropDownProjects.addEventListener('mouseleave', hideDropDown);

